export enum FeatureListTypes {
  DESIGN,
  ERRORS,
}

export { default as FeaturesList } from "./FeaturesList";
export { default as FeaturesTable } from "./FeaturesTable";
